require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-personalization-demystified.json") })
        }
      }, "path---posts-personalization-demystified");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-personalization-demystified!./.cache/json/posts-personalization-demystified.json
// module id = 367
// module chunks = 231608221292675